<div *ngIf="!refreshing; else: spinner" id="consultNoteDetailPage">
  <app-consult-note-title [patientAttachment]="patientAttachment" />
  <app-consult-note-header [patientAttachment]="patientAttachment" />
  <app-validate-patient-prescriptions
    [patientAttachment]="patientAttachment"
  />
</div>
<ng-template #spinner> <mat-spinner /> </ng-template>
